import { render, staticRenderFns } from "./MtMaterialsCateForm.vue?vue&type=template&id=ada54e52&"
import script from "./MtMaterialsCateForm.vue?vue&type=script&lang=js&"
export * from "./MtMaterialsCateForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports